// Pending = 0,
// InEvaluation = 1,
// InRevision = 2,
// Cancel = 3,
// Accept = 4,

export const courseEvaluateEnum = {
    Pending:0,
    InEvaluation:1,
    InRevision:2,
    Cancel:3,
    Accept:4
}